'use strict';
const angular = require('angular');
var appUser = [];
var baseURL, appURL;
var rowSelectedCollection = [];

// baseURL = 'http://localhost:3000'; //local development
// baseURL = 'http://hess-api-test.us-west-2.elasticbeanstalk.com'; //development
// baseURL = 'https://hess.abag.ca.gov'; //production

/*@ngInject*/
export function dbService() {

  this.getBaseURL = function(){
    return baseURL;
  }
  

  this.setUser = function(user){
   appUser = user;
  }


  this.getUser = function(){
    return appUser;
  }

  this.setRowSelectedCollection = function(rowCollection){
    rowSelectedCollection = rowCollection;
   }
 
 
   this.getRowSelectedCollection = function(){
     return rowSelectedCollection;
   }
}

export default angular.module('hessApplicationApp.db', [])
  .service('db', dbService)
  .name;



// WEBPACK FOOTER //
// ./client/components/services/db/db.service.js